import { IsNotEmpty, IsIn, IsOptional } from "class-validator";
import { Constants } from "@eagerdog/constants";

import { IProperty } from "../common";

export class RegistrationNumberDto implements IProperty {
  //
  @IsOptional()
  @IsIn(Object.values(Constants.registration_number_type))
  type?: string;

  @IsNotEmpty()
  @IsIn(Object.values(Constants.sanctioning_club))
  name: string;

  @IsNotEmpty()
  value: any;
}
